import React from "react";
import ReactGA from "react-ga";
import Hammer from "react-hammerjs";
import {HeaderComponent} from "./../Common/HeaderComponent";

import "./../../css/image-viewer.css";

const LANDSCAPE_VIEW = "landscape";
const PORTRAIT_VIEW = "portrait";
const INFO_PANEL_CLASS = "image-info-panel";
const IMAGE_CONTAINER_CLASS = "image-container";
const MOBILE_IMAGE_CONTAINER_CLASS = "mobile image-container";

const DURATION = 5000;

const MAX_WIDTH_MOBILE_PHONE_PORTRAIT_ORIENTATION = 480;
const MOBILE_SAFARI_ACTION_BAR_HEIGHT = 75;

let imageHeight = 0;
let imageWidth = 0;

let myTimer = null;

export class ImageViewerComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            imageClass: LANDSCAPE_VIEW,  // default
            imageContainerClass: IMAGE_CONTAINER_CLASS,
            infoPanelClass: INFO_PANEL_CLASS,
            showNavButtons: true,
            imageLoaded: false
        }
        imageWidth = 0;
        imageHeight = 0;
        myTimer = null;

        this.stopTimer = this.stopTimer.bind(this);
        this.toggleIconVisibility = this.toggleIconVisibility.bind(this);
        this.showIcons = this.showIcons.bind(this);

        this.handleImageOnLoad = this.handleImageOnLoad.bind(this);
        this.handleOrientationChange = this.handleOrientationChange.bind(this);

        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
        this.handleNextButtonClick = this.handleNextButtonClick.bind(this);
        this.handlePreviousButtonClick = this.handlePreviousButtonClick.bind(this);
        this.handleSwipeLeft = this.handleSwipeLeft.bind(this);
        this.handleSwipeRight = this.handleSwipeRight.bind(this);

        this.handleToggleInfoPanel = this.handleToggleInfoPanel.bind(this);
        this.disableContextMenu = this.disableContextMenu.bind(this);
        this.isMobileSafari = this.isMobileSafari.bind(this);
    }

    componentDidMount() {
        this.viewer.addEventListener("orientationchange", this.handleOrientationChange);
        window.addEventListener("resize", this.handleOrientationChange);
        window.addEventListener("keydown", this.handleKeyPress);

        // first time starting myTimer
        this.stopTimer();
        myTimer = setTimeout(this.toggleIconVisibility, DURATION);
    }

    componentWillUnmount() {
        this.viewer.removeEventListener("orientationchange", this.handleOrientationChange);
        window.removeEventListener("resize", this.handleOrientationChange);
        window.removeEventListener("keydown", this.handleKeyPress);
        this.stopTimer();
    }

    disableContextMenu(event) {
        //event.preventDefault();
    }

    stopTimer() {
        if (myTimer !== null) {
            clearTimeout(myTimer);
            myTimer = null;
        }
    }

    toggleIconVisibility() {
        if (this.state.infoPanelClass !== INFO_PANEL_CLASS) {
            // info panel is visible
            return;
        }
        this.stopTimer();
        const isIconVisibleNow = this.state.showNavButtons;

        // this.setState({
        //     showNavButtons: !isIconVisibleNow
        // });

        // when setState relies on previous state value, calling setState this way is more proper
        // pass in a function
        this.setState(function(prevState) {
            return {
                showNavButtons: !prevState.showNavButtons
            }
        });

        if (!isIconVisibleNow) {
            myTimer = setTimeout(this.toggleIconVisibility, DURATION);
        }
    }

    showIcons() {
      this.stopTimer();
      this.setState({
          showNavButtons: true
      });
      myTimer = setTimeout(this.toggleIconVisibility, DURATION);
    }

    handleImageOnLoad({target:img}) {
        imageWidth = img.width || 0;
        imageHeight = img.height || 0;

        // Tracking
        ReactGA.event({
            category: "PhotoViewer",
            action: "View",
            label: "photo-viewed: " + this.props.category.toLowerCase() + "/" + this.props.photo.name.toLowerCase()
        });

        this.handleOrientationChange();

        this.setState({
            imageLoaded: true
        });

        // Preload the next image then prev image
        if (this.props.nextPhoto) {
            const nextImgSrc = require("./../../images/" + this.props.category + "/" + this.props.nextPhoto.name + ".jpg");
            let nextImage = new Image();

            const that = this;
            nextImage.onload = function() {
                // load prev photo when done loading itself
                if (that.props.prevPhoto) {
                    const prevImgSrc = require("./../../images/" + that.props.category + "/" + that.props.prevPhoto.name + ".jpg");
                    let prevImage = new Image();
                    prevImage.src = prevImgSrc;
                }
            }

            nextImage.src = nextImgSrc;
        }
    }

    isMobileSafari() {
        const ua = window.navigator.userAgent;
        const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        const webkit = !!ua.match(/WebKit/i);
        return iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/OPiOS/i);  //last two is to exclude Chrome and Opera browsers
    }

    handleOrientationChange() {
        // const viewPortWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
        // const viewPortHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        // const viewPortRatio = viewPortWidth / viewPortHeight;
        if (imageHeight <= 0) {
            return;
        }

        const container = document.getElementById("image-container");
        let containerRatio = (container.getBoundingClientRect().right - container.getBoundingClientRect().left) / (container.getBoundingClientRect().bottom - container.getBoundingClientRect().top);
        const imageRatio = imageWidth / imageHeight;

        if (this.isMobileSafari() && window.screen.width <= MAX_WIDTH_MOBILE_PHONE_PORTRAIT_ORIENTATION) {
            containerRatio = (container.getBoundingClientRect().right - container.getBoundingClientRect().left) / (container.getBoundingClientRect().bottom - container.getBoundingClientRect().top - MOBILE_SAFARI_ACTION_BAR_HEIGHT);
            this.setState({
                imageContainerClass: MOBILE_IMAGE_CONTAINER_CLASS
            });
        } else {
            this.setState({
                imageContainerClass: IMAGE_CONTAINER_CLASS
            });
        }

        let orientation = LANDSCAPE_VIEW;
        if (imageRatio < containerRatio) {
            orientation = PORTRAIT_VIEW;
        }

        this.setState({
            imageClass: orientation
        });
    }

    handleKeyPress(event) {
        const evt = event || window.event;
        let isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key.toLowerCase() === "escape" || evt.key.toLowerCase() === "esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {

            // Tracking
            ReactGA.event({
                category: "PhotoViewer",
                action: "Keypress",
                label: "escape-key"
            });

            this.handleCloseButtonClick(event);
        }
    }

    handleCloseButtonClick(event) {
        this.stopTimer();
        this.props.closeButtonClick();
        event.stopPropagation();

        // Tracking
        ReactGA.event({
            category: "PhotoViewer",
            action: "Click",
            label: "close-button"
        });
    }

    handleNextButtonClick(event) {
        //this.handleSwipeLeft();
        if (this.state.infoPanelClass === INFO_PANEL_CLASS) {
            this.stopTimer();
            this.props.nextButtonClick();
            //if (this.state.showNavButtons) {
            this.showIcons();
            //}
        }
        event.stopPropagation();

        // Tracking
        ReactGA.event({
            category: "PhotoViewer",
            action: "Click",
            label: "next-button"
        });
    }

    handlePreviousButtonClick(event) {
        //this.handleSwipeRight();
        if (this.state.infoPanelClass === INFO_PANEL_CLASS) {
            this.stopTimer();
            this.props.previousButtonClick();
            //if (this.state.showNavButtons) {
            this.showIcons();
            //}
        }
        event.stopPropagation();

        // Tracking
        ReactGA.event({
            category: "PhotoViewer",
            action: "Click",
            label: "previous-button"
        });
    }

    handleSwipeLeft() {
        if (!this.state.imageLoaded) {
            return;
        }

        if (this.state.infoPanelClass === INFO_PANEL_CLASS) {
            this.stopTimer();
            this.props.nextButtonClick();
            //if (this.state.showNavButtons) {
            this.showIcons();
            //}
        }
        // Tracking
        ReactGA.event({
            category: "PhotoViewer",
            action: "Swipe",
            label: "swipe-left"
        });
    }

    handleSwipeRight() {
        if (!this.state.imageLoaded) {
            return;
        }

        if (this.state.infoPanelClass === INFO_PANEL_CLASS) {
            this.stopTimer();
            this.props.previousButtonClick();
            //if (this.state.showNavButtons) {
            this.showIcons();
            //}
        }
        // Tracking
        ReactGA.event({
            category: "PhotoViewer",
            action: "Swipe",
            label: "swipe-right"
        });
    }

    handleToggleInfoPanel(event) {
        let elemClass = INFO_PANEL_CLASS;
        if (this.state.infoPanelClass === INFO_PANEL_CLASS) {
            elemClass = elemClass + " show";
            this.toggleIconVisibility();

            // Tracking
            ReactGA.event({
                category: "PhotoViewer",
                action: "Click",
                label: "show-photo-detail-button: " + this.props.category.toLowerCase() + "/" + this.props.photo.name.toLowerCase()
            });

        } else {
            this.showIcons();
        }
        this.setState({
            infoPanelClass: elemClass
        });
        event.stopPropagation();
    }

    render() {
        const imageSrc = require("./../../images/" + this.props.category + "/" + this.props.photo.name + ".jpg");

        let closeButton = <div className="hamburger hamburger-htx is-active nav-icon close-icon hide"><span>&nbsp;</span></div>;
        let leftButton = <span><i className="fa fa-angle-left fa-2x nav-icon left-icon hide" aria-hidden="true"></i></span>;
        let rightButton = <span><i className="fa fa-angle-right fa-2x nav-icon right-icon hide" aria-hidden="true"></i></span>;
        let drawerButton = <div className="drawer hide"><span>Details&nbsp;&nbsp;</span><i className="fa fa-info-circle fa-lg nav-icon drawer-icon hide" aria-hidden="true"></i></div>;

        if (this.state.showNavButtons) {
            closeButton = <div className="hamburger hamburger-htx is-active nav-icon close-icon" onClick={this.handleCloseButtonClick}><span>&nbsp;</span></div>;
            drawerButton = <div className="drawer" onClick={this.handleToggleInfoPanel}><span>Details&nbsp;&nbsp;</span><i className="fa fa-info-circle fa-lg nav-icon drawer-icon" aria-hidden="true"></i></div>;

            if (this.props.index > 0) {
                leftButton = <span onClick={this.handlePreviousButtonClick}><i className="fa fa-angle-left fa-2x nav-icon left-icon" aria-hidden="true"></i></span>;
            }
            if (this.props.index + 1 < this.props.totalMatchedPhotos) {
                rightButton = <span onClick={this.handleNextButtonClick}><i className="fa fa-angle-right fa-2x nav-icon right-icon" aria-hidden="true"></i></span>;
            }
        }

        let loading = "";
        if (!this.state.imageLoaded) {
            let loadingImageSrc = require("./../../images/loading.svg");
            loading = <div className="loading"><img src={loadingImageSrc} alt="" /></div>;
        }

        return (
            <div ref={elem => this.viewer = elem} className="image-viewer-component" onClick={this.toggleIconVisibility}>
                <Hammer onSwipeRight={this.handleSwipeRight} onSwipeLeft={this.handleSwipeLeft}>
                    <div id="image-container" className={this.state.imageContainerClass} onContextMenu={this.disableContextMenu}>
                        <div className="inner-image-container">
                            {loading}
                            <img className={this.state.imageClass} src={imageSrc} alt="" onLoad={this.handleImageOnLoad} />
                            {closeButton}
                            {leftButton}
                            {rightButton}
                            {drawerButton}
                            <div className={this.state.infoPanelClass} onClick={this.handleToggleInfoPanel}>
                                <div className="hamburger hamburger-htx is-active nav-icon close-icon"><span>&nbsp;</span></div>
                                <HeaderComponent header={this.props.photo.title} subHeader={this.props.photo.description} subText={this.props.photo.location} />
                            </div>
                        </div>
                        <div className="filler"></div>
                    </div>
                </Hammer>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Common/ImageViewerComponent.js